<script>
  export let file

  let fileData = file.file[0]
</script>

<article>
  <h2 class="t-small-caps">{file.name}</h2>
  <a href={fileData.url} aria-label={`${file.name} runterladen`} download=""
    >Download</a
  >
</article>
